import script from "./SettingsHowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsHowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./SettingsHowItWorks.vue?vue&type=style&index=0&id=09502d60&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09502d60"]])

export default __exports__